/**
 * @项目名称: bjxy
 * @功能名称: vue扩展生命周期钩子 appBack appClose
 * @文件名称: vueHook
 * @Date: 2018/12/26
 * @Author: liux
 * @Copyright（C）2018 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */


import registAppBack from '../xyJsBridge/registAppBack'
import registAppClose from '../xyJsBridge/registAppClose'
import closeCurrentPage from '../xyJsBridge/closeCurrentPage'



export  default  function  (router) {
  // 用户点击后退
  registAppBack(REGISTHOOK('appBack',appBack));
  // 用户点击关闭
  registAppClose(REGISTHOOK('appClose',closeCurrentPage))
  // webview 进入后台
  window.onPause = REGISTHOOK('appPause')
  // webview 恢复
  window.onResume = REGISTHOOK('appResume')
  window.router = router
  var rootKey = history.state && history.state.key
  var realReplaceState = history.replaceState;

  document.addEventListener('DOMContentLoaded',function() {
    rootKey = history.state && history.state.key;
  })
  history.replaceState = function() {
    setRootKey(arguments[0])
    return realReplaceState.call(history,...arguments)
  }
  function setRootKey(state={key:null}) {
    let key = history.state && history.state.key;
    if(rootKey === key){
      rootKey = state.key
    }
  }
  function appBack() {
    let key = history.state && history.state.key
    if(rootKey === key){
      closeCurrentPage()
    }else {
      router.back()
    }
  }
  function REGISTHOOK(name,next = function () {}) {
    return function () {
      var mvList = router.currentRoute && router.currentRoute.matched;
      if(!Array.isArray(mvList)){
        return next();
      }
      mvList = mvList.slice().map((item)=>{
        return item.instances && item.instances.default
      });
      var check = mvList.some(vm=>{
        var hook = vm && vm.$options && vm.$options[name];
        if(typeof hook === 'function'){
          return true
        }else {
          return false
        }
      })
      if(!(mvList && check)){
        return next()
      }
      var appDefault =  true
      mvList.reverse().some(item=>{
        let hook = item && item.$options && item.$options[name];
        if(typeof  hook === 'function'){
          let prevent = true; // 执行默认事件
          let stop = false; // 不阻止冒泡
          appDefault = false;
          let re = hook.call(item,next,{
            stopPropagation: ()=>{
              stop = true;
            },
            preventDefault:  ()=> {
              prevent = false
            }}) === false; // re: true -- 阻止默认事件，阻止冒泡
          if(!re && prevent){
            next()
          }
          return re || stop
        }else {
          return false
        }
      })
      if(appDefault){
        next()
      }
    }
  }
}
